import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-product-hire-service',
    templateUrl: './product-hire-service.component.html',
    styleUrls: ['./product-hire-service.component.scss']
})
export class ProductHireServiceComponent {

    @Input() data;

    private readonly iconBase = 'resources/assets/images/main-page/';
    // Solo iconos blancos renderizan sobre el círculo azul (house.svg y shield.svg
    // son azules). Se usan los mismos SVG blancos que other-insurance.
    private readonly iconMap: { [key: string]: string } = {
        legal: 'onlygal-abogado-365.svg',
        home: 'onlygal-compraventa-asegurada.svg',
        car: 'car.svg',
        community: 'onlygal-abogado-365.svg'
    };

    iconSrc(): string {
        const key = (this.data && this.data.icon) ? String(this.data.icon).toLowerCase().trim() : '';
        return this.iconBase + (this.iconMap[key] || 'onlygal-abogado-365.svg');
    }

    openExternalLink() {
        if (this.data && this.data.link) {
            window.open(this.data.link, '_blank');
        }
    }
}
